var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2006_2438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.2861 114C74.2861 114 145.98 105.391 151.266 103.49C156.551 101.588 158.158 86.0146 152.186 84.4232C146.212 82.8351 78.6547 79.3457 78.6547 79.3457L0.00927734 82.0133L74.2861 114Z",
    fill: "#448F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.265 103.489C145.979 105.39 74.2857 113.999 74.2857 113.999L39.4106 93.6265L74.4403 86.8496L154.4 86.0312C157.581 90.454 155.743 101.88 151.265 103.489Z",
    fill: "#54B14C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90137 83.7734C16.4903 84.1217 68.5621 85.6052 75.665 89.1016C83.9383 93.1761 81.1794 111.323 74.2873 112.18C68.7027 112.873 20.149 105.445 1.90488 102.6V83.7734H1.90137Z",
    fill: "#EEE6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00702929 100.55C22.2226 104.04 67.5323 110.869 73.8796 110.5C73.9886 110.493 74.087 110.486 74.1713 110.476C75.9989 110.249 77.7773 107.637 78.5927 103.981C79.7384 98.8371 78.8141 92.6034 74.8251 90.6393C68.527 87.5365 20.5145 85.8788 0.00351464 85.4365V82.0098C12.3959 82.2744 68.6183 83.6744 76.498 87.5573C82.2197 90.3747 83.3373 98.3321 81.9526 104.534C80.7647 109.863 77.8687 113.443 74.3963 113.874C74.2873 113.888 74.1608 113.899 74.0202 113.906C66.4991 114.341 17.3479 106.77 0 104.047V100.55H0.00702929Z",
    fill: "#4CA045"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.2864 92.0313L2.82129 86.4941C2.82129 86.4941 60.6112 89.409 74.2864 92.0313Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1443 93.9571L3.6792 88.4199C3.6792 88.4199 61.4727 91.3348 75.1443 93.9571Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9822 96.0723L4.25537 90.166C4.25537 90.166 63.3071 93.45 76.9822 96.0723Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0663 98.3021L4.37109 91.668C4.37109 91.668 63.3947 95.6798 77.0663 98.3021Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0663 100.306L4.37109 93.2188C4.37109 93.2188 63.3947 97.6833 77.0663 100.306Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0663 102.185L4.37109 94.5098C4.37109 94.5098 63.3947 99.5594 77.0663 102.185Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5113 103.556L4.25537 95.9707C4.25537 95.9707 62.8396 100.933 76.5113 103.556Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.511 105.176L4.37109 97.4414C4.37109 97.4414 62.8394 102.55 76.511 105.176Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4854 107.113L4.0835 98.4551C4.0835 98.4551 61.8102 104.49 75.4854 107.113Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2862 108.843L3.68213 99.7188C3.67861 99.7188 60.611 106.217 74.2862 108.843Z",
    fill: "#E8D3C1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.9287 51.1391V78.1945C23.9287 78.1945 55.5563 81.9172 62.4202 80.0088C69.2842 78.1039 66.0754 68.8405 66.0754 64.484C66.0754 60.1274 65.984 49.5024 64.8839 46.9602C63.7839 44.4179 58.5612 45.508 52.1471 46.0512C45.7331 46.598 23.9287 51.1391 23.9287 51.1391Z",
    fill: "#EEE6DE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9096 47.3779L24.2339 53.3399C24.2339 53.3399 57.6785 47.2908 65.9096 47.3779Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9958 62.9485L24.9546 64.5435C24.9546 64.5435 58.8139 62.064 66.9958 62.9485Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9952 61.2219L24.9751 63.9034C24.9751 63.9034 58.7957 60.4906 66.9952 61.2219Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9952 60.175L24.9751 62.8565C24.9751 62.8565 58.7957 59.4437 66.9952 60.175Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9818 58.7986L24.9897 61.898C24.9897 61.898 58.7752 58.1474 66.9818 58.7986Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.943 56.9673L25.0283 60.9548C25.0283 60.9548 58.726 56.4902 66.943 56.9673Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.943 55.6568L25.0283 59.6373C25.0283 59.6373 58.726 55.1797 66.943 55.6568Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9223 54.0429L25.0498 58.4378C25.0498 58.4343 58.7017 53.6459 66.9223 54.0429Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9223 52.539L25.0498 56.9339C25.0498 56.9339 58.7017 52.142 66.9223 52.539Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.897 50.9978L25.0737 55.8454C25.0737 55.8454 58.6694 50.6879 66.897 50.9978Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0801 49.2947L25.2568 54.1423C25.2568 54.1423 58.8525 48.9847 67.0801 49.2947Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7719 77.2315L24.3984 75.041C24.3984 75.041 57.6005 78.0742 65.7719 77.2315Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8305 64.2422L25.1196 65.3879C25.1196 65.3879 58.6064 65.4227 66.8305 64.2422Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8164 65.6309L25.1372 66.3517C25.1372 66.3517 58.6732 67.0378 66.8164 65.6309Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7812 67.476L25.1758 67.2949C25.1758 67.2949 58.6274 68.7088 66.7812 67.476Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7846 68.8011L25.1792 68.627C25.1757 68.627 58.6273 70.0339 66.7846 68.8011Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7635 70.4275L25.1968 69.832C25.2003 69.8355 58.6062 71.5802 66.7635 70.4275Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7664 71.9412L25.1997 71.3457C25.1997 71.3492 58.6056 73.0939 66.7664 71.9412Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7456 73.4966L25.228 72.4414C25.228 72.4414 58.5812 74.5622 66.7456 73.4966Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9287 75.1978L25.4111 74.1426C25.4111 74.1426 58.7643 76.2634 66.9287 75.1978Z",
    fill: "#E8D3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1033 78.5133L24.041 76.584C24.041 76.584 57.9214 79.3909 66.1033 78.5133Z",
    fill: "#E8D3C1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.7806 43.0801C61.7806 43.0801 130.726 53.3429 136.342 55.2513C141.962 57.1632 141.22 71.4831 140.25 76.6511C139.28 81.8191 135.485 83.1877 131.453 83.1877C127.422 83.1877 60.0796 82.3345 60.0796 82.3345C60.0796 82.3345 65.355 81.0565 66.3812 73.7711C67.4075 66.4823 65.7591 51.8489 65.4393 49.359C65.1195 46.869 61.7806 43.0801 61.7806 43.0801Z",
    fill: "#54B14C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1912 62.7771C68.1385 61.6697 68.0858 60.5971 68.0507 59.5976C68.0296 58.9325 68.012 58.2604 67.9944 57.5848C67.8679 52.3437 67.7379 46.9249 64.6942 44.3723C63.3201 43.2196 61.5417 42.7912 59.4048 43.0942C53.2649 43.9683 27.3204 48.4851 21.7252 49.4602V53.1481C25.3803 52.5108 53.6409 47.5831 59.925 46.6881C61.3449 46.4861 61.9775 46.8518 62.3254 47.1443C64.1108 48.6418 64.2268 53.4406 64.3287 57.6718C64.3463 58.3579 64.3604 59.0439 64.385 59.7195C64.4201 60.7364 64.5115 62.5125 64.5256 62.9513C64.5537 63.8846 65.0141 77.0135 62.814 78.3786C60.3713 79.4826 40.1099 78.4448 21.7217 76.7976V80.4437C28.8703 81.081 45.336 82.4427 55.7637 82.4427C60.0515 82.4427 63.3165 82.2128 64.4939 81.6069C68.989 79.298 68.5849 70.8983 68.1912 62.7771Z",
    fill: "#4CA045"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2006_2438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 156,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.626ec81f5e8d157a9ab422886f708938.svg";
export { ForwardRef as ReactComponent };